import { clearSessionAction } from '@app-worker/auth/clearSessionAction';
import { clearPushSubscription as clearBrowserPushSubscription } from '@app-worker/shared/workerDevice/clearWorkerDevice/clearPushSubscription/clearPushSubscription';
import { offlineVisitsStorage } from '@app-worker/shared/visit/offlineVisits/offlineVisitsStorage/offlineVisitsStorage';
import { clearBrowserUIEventBuffer } from '@repo/features/clearBrowserUIEventBuffer';

/**
 * Everything on the phone a signed-out worker must not leave behind: his
 * unsent UI events, the visits list saved for the offline page, his push
 * subscription (so the office's messages to him stop chiming here), and his
 * session. The push goes before the session, since deleting its row needs him
 * signed in.
 * Caio and David sign in as workers all winter, so the next person must start
 * clean. Every logout and the login page go through here, so a new thing to
 * clear is added once.
 *
 * The effects are parameters only so the spec needs no server.
 */
export async function clearWorkerDevice({
  clearUIEventBuffer = clearBrowserUIEventBuffer,
  clearOfflineVisits = offlineVisitsStorage.clear,
  clearPushSubscription = clearBrowserPushSubscription,
  clearSession = clearSessionAction,
}: {
  clearUIEventBuffer?: () => void;
  clearOfflineVisits?: () => void;
  clearPushSubscription?: () => Promise<void>;
  clearSession?: () => Promise<void>;
} = {}) {
  clearUIEventBuffer();
  clearOfflineVisits();
  await clearPushSubscription();
  await clearSession();
}
